const API_HOST = 'https://docflow.rbc-group.uz/api/v1/'
const CLOUD_URL = 'http://cloud.xtv.uz/'
const HOST = 'https://docflow.rbc-group.uz/'
const INCTRUCTION_URL = 'http://ijro.xtv.uz/education/yoriqnoma.docx'
const WARNING_MESSAGE = `<span>Bu o'quv maqsadlarda o'rnatilgan Elektron xujjat almashinuv tizimi. Ishlash uchun <a href="https://ijro.xtv.uz ">https://ijro.xtv.uz</a> adresida joylashgan</span><br><span>Это ТЕСТОВЫЙ СЕРВЕР СЭД Министерства народного образования. Боевой сервер СЭД расположен по адресу <a href="https://ijro.xtv.uz ">https://ijro.xtv.uz</a></span>`
const ANDROID_APP = 'https://docflow.rbc-group.uz/assets/downloads/docflow.apk'

export {
  API_HOST,
  CLOUD_URL,
  HOST,
  INCTRUCTION_URL,
  WARNING_MESSAGE,
  ANDROID_APP,
}
